import noUiSlider from "nouislider"

window.initDoubleRangeSlider = (selector) => {
	const item = document.querySelector(selector)
	if (!item) return

	const rangeItem = item.querySelector(".default-range__slider")
	const inputStart = item.querySelector(`[data-id='input-start']`)
	const inputEnd = item.querySelector(`[data-id='input-end']`)
	const pips = item.querySelectorAll(".default-range__pips-item")

	const currentStartValue = inputStart.value;
	const currentEndValue = inputEnd.value;

	const startValue = +inputStart.min
	const endValue = +inputEnd.max
	const step = +rangeItem.getAttribute("data-range-step") || 1

	function formatInputsInitialValues(el) {
		if (el.value) {
			let tempVal = Math.round(el.value.replace(/\D/g, ""))
			if (tempVal >= startValue && tempVal <= endValue) {
				el.value = tempVal
			} else if (tempVal < startValue) {
				el.value = startValue
			} else {
				el.value = endValue
			}
		}
	}

	formatInputsInitialValues(inputStart)
	formatInputsInitialValues(inputEnd)

	const startSliderValue = inputStart.value ? Math.round(inputStart.value.replace(/\D/g, "")) : startValue
	const endSliderValue = inputEnd.value ? Math.round(inputEnd.value.replace(/\D/g, "")) : endValue

	noUiSlider.create(rangeItem, {
		start: [startSliderValue, endSliderValue],
		range: { min: startValue, max: endValue },
		step: step,
		tooltips: true,
		format: {
			from: String,
			to: function(value) {
				return (parseInt(value).toLocaleString())
			}
		},
		connect: true
	})

	if (inputStart && inputEnd) {
		rangeItem.noUiSlider.on("change", function(values, handle) {

			let value0 = Math.round(+values[0].replace(/\D/g, ""))
			let value1 = Math.round(+values[1].replace(/\D/g, ""))

			inputStart.value = value0
			inputEnd.value = value1
			inputStart.dispatchEvent(new Event("change", { bubbles: true }))
			inputEnd.dispatchEvent(new Event("change", { bubbles: true }))
		})

		inputStart.addEventListener("change", function(e) {
			let processed = e.target.value.replace(/ /g, "")
			let output = parseInt(processed, 10)

			if (output > endValue) {
				rangeItem.noUiSlider.set([endValue, null])
				e.target.value = endValue
			} else if (output < startValue) {
				rangeItem.noUiSlider.set([startValue, null])
				e.target.value = startValue
			} else {
				rangeItem.noUiSlider.set([output, null])
			}
		})
		inputEnd.addEventListener("change", function(e) {
			let processed = e.target.value.replace(/ /g, "")
			let output = parseInt(processed, 10)

			if (output > endValue) {
				rangeItem.noUiSlider.set([null, endValue])
				e.target.value = endValue
			} else if (output < startValue) {
				rangeItem.noUiSlider.set([null, startValue])
				e.target.value = startValue
			} else {
				rangeItem.noUiSlider.set([null, output])
			}
		})
	}

	window.filterRangeSliders.push(rangeItem.noUiSlider)
}



// WEBPACK FOOTER //
// ./src/js/rangeSlider.js